import { ErrorBoundary, Head } from "@/components"
import { SliceRender } from "@/components/Marketing/Slice"
import { MarketingContentDocument } from "@/lib/prismicio/types.generated"
import { asText } from "@prismicio/helpers"

export const Marketing = ({ prismic }: { prismic: MarketingContentDocument["data"] }) => (
    <ErrorBoundary system="marketing">
        <Head
            title={asText(prismic.meta_tag_title)}
            robots={asText(prismic.meta_tag_robots)}
            description={asText(prismic.meta_tag_description)}
        />
        <div className="bg-white pb-2.5">
            <SliceRender slices={prismic.body} />
        </div>
    </ErrorBoundary>
)
